import React from 'react';
import { useConference, joinConference } from '../services/conference';
import '../styles/Conference.css';

// Плашка над чатом в любом канале: «Идёт конференция, вы приглашены»
function ConferenceBanner({ user }) {
  const { active, call } = useConference();
  const visible = active.filter(c => !call || call.confId !== c.id);
  if (!visible.length) return null;

  return (
    <div className="conf-banners">
      {visible.map(c => {
        const mine = c.createdBy === user.id;
        const online = (c.online || []).length;
        return (
          <div key={c.id} className="conf-banner">
            <span className="conf-banner-icon">🎥</span>
            <div className="conf-banner-text">
              <b>Идёт конференция</b>
              <span>
                {mine ? 'Вы её начали' : `${c.creatorName} приглашает вас`}
                {online ? ` · сейчас в ней: ${online}` : ''}
              </span>
            </div>
            <button className="conf-btn-primary" onClick={() => joinConference(c.id)}>
              Присоединиться
            </button>
          </div>
        );
      })}
    </div>
  );
}

export default ConferenceBanner;
